import { CLOUDINARY_PREFIX, MOCK_UP_LAYERS } from '../constants';

const {
    IMAGE_LAYER,
    VARIATION_LAYER,
    BACKGROUND_LAYER
} = MOCK_UP_LAYERS;

const CARDS_HARD_SHADOW = `${CLOUDINARY_PREFIX}562898f3c2eaf82b59c2b00a2428ab86-1577120240798/Cards%20Hard%20Shadow.png`;
const DARK_CARDS = `${CLOUDINARY_PREFIX}562898f3c2eaf82b59c2b00a2428ab86-1577120240806/Dark%20cards.png`;
const BACKGROUND_GRADIENT = `${CLOUDINARY_PREFIX}562898f3c2eaf82b59c2b00a2428ab86-1577120240795/Background%20gradient.png`;
const WHITE_CARDS_BASE = `${CLOUDINARY_PREFIX}562898f3c2eaf82b59c2b00a2428ab86-1577120240791/Cards%20with%20notchangable%20grey%20bg.png`;

const WIDE_CARD_SCALE = 0.19;
const SQUARE_CARD_SCALE = 0.4;
const SQUARE_CROP_STYLE = {
    transformOrigin: 'top left',
    transform: 'scale(2.3) translate(-27%, -3%)'
};

export const wideMockUp = {
    layers: [
        {
            type: IMAGE_LAYER,
            src: WHITE_CARDS_BASE
        }, {
            type: BACKGROUND_LAYER,
            mixBlendMode: 'multiply'
        }, {
            type: IMAGE_LAYER,
            src: BACKGROUND_GRADIENT
        },
        {
            type: VARIATION_LAYER,
            transform: `translate(-51%, -55%) rotate(-4.5deg) scale(${WIDE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: VARIATION_LAYER,
            transform: `translate(-95%, -27%) rotate(20deg) scale(${WIDE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: VARIATION_LAYER,
            transform: `translate(-80%, -68%) rotate(22deg) scale(${WIDE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: VARIATION_LAYER,
            transform: `translate(-13%, -72%) rotate(-22deg) scale(${WIDE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: VARIATION_LAYER,
            transform: `translate(-35%, -26%) rotate(14deg) scale(${WIDE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: IMAGE_LAYER,
            src: DARK_CARDS
        }, {
            type: IMAGE_LAYER,
            opacity: 0.34,
            mixBlendMode: 'color-burn',
            src: CARDS_HARD_SHADOW
        }
    ],
    aspectRatio: '56.25%'
};

export const squareMockUp = {
    layers: [
        {
            type: IMAGE_LAYER,
            src: WHITE_CARDS_BASE,
            ...SQUARE_CROP_STYLE
        }, {
            type: BACKGROUND_LAYER,
            mixBlendMode: 'multiply',
            ...SQUARE_CROP_STYLE
        }, {
            type: IMAGE_LAYER,
            src: BACKGROUND_GRADIENT,
            ...SQUARE_CROP_STYLE
        },
        {
            type: VARIATION_LAYER,
            transform: `translate(-49%, -50.5%) rotate(-4.5deg) scale(${SQUARE_CARD_SCALE})`,
            opacity: 0.95
        }, {
            type: IMAGE_LAYER,
            src: DARK_CARDS,
            ...SQUARE_CROP_STYLE
        }, {
            type: IMAGE_LAYER,
            opacity: 0.34,
            mixBlendMode: 'color-burn',
            src: CARDS_HARD_SHADOW,
            ...SQUARE_CROP_STYLE
        }
    ],
    aspectRatio: '100%'
};
